export interface UserGroup {
  readonly type: UserGroupType;
  id: string;
  displayName: string;
  createdAt: number;
  createdBy: string;
}

export enum UserGroupType {
  ORGANISATION = 'ORGANISATION',
  DISCIPLINE = 'DISCIPLINE'
}
